import type React from 'react';
import { memo } from 'react';

import { PageLoader } from '@/shared/ui/page-loader';

interface SubscriptionOnboardingStepProps {
    renderPlanSelector?: (() => React.ReactNode) | undefined;
}

export const SubscriptionOnboardingStep = memo(
    (props: SubscriptionOnboardingStepProps) => {
        const { renderPlanSelector } = props;

        if (renderPlanSelector) {
            return <>{renderPlanSelector()}</>;
        }

        return <PageLoader />;
    },
);

SubscriptionOnboardingStep.displayName = 'SubscriptionOnboardingStep';
